//
//
//
//
//

export default {
    props: {
        open_type: {
            type: String
        },
        msg: {
            type: String,
            default: ''
        },
        card: {
            type: Object,
            default: null
        },
        show_cancel: {
            type: Boolean,
            default: true,
        },
        show_confirm: {
            type: Boolean,
            default: true,
        },
        confirm_text: {
            type: String,
            default: '接受'
        },
        cancel_text: {
            type: String,
            default: '拒绝'
        }
    },
    methods: {
        onConfirm () {
            if (!this.open_type) {
                this.$emit('confirm')
            }
        },
        getPhoneNumber (e) {
            if (this.open_type === 'getPhoneNumber') {
                this.$emit('getPhoneNumber', e)
            }
        }
    }
}
